import styled from 'styled-components';
import { Content } from '../../../theme/layout';
import { Carousel } from '../../../shared/components/carousel';
import { Icon, ICON_ARROW_LEFT, ICON_ARROW_RIGHT } from '../../../shared/components/icon';
import { themeColor } from '../../../theme/getters';
import { contentPadding } from '../../../theme/mixins';
import { media } from '../../../theme/media';

const SLIDE_SPACING = '28px';

export const Container = styled(Content)`
  padding: 0;
  ${media.tablet`
    ${contentPadding};
    padding-top: 56px;
  `}
`;

export const RelativeWrapper = styled.div`
  position: relative;
`;

export const Slider = styled(Carousel)`
  background-color: ${themeColor('primary')};

  .slick-list {
    ${media.tablet`
      margin: 0 -${SLIDE_SPACING};
    `}
  }

  .slick-track {
    display: flex;

    .slick-slide {
      display: flex;
      height: auto;
      transition: opacity 750ms ease-in-out 0s, visibility 100ms ease 0s !important;

      > * {
        flex: 1;
      }
    }
  }
`;

export const Slide = styled.div`
  height: 100%;

  ${media.tablet`
    padding: 0 ${SLIDE_SPACING};
  `}
`;

const Arrow = styled(Icon).attrs(props => ({ color: themeColor('white')(props), stroked: true, size: 48 }))`
  position: absolute;
  font-size: 19px;
  z-index: 1;
  cursor: pointer;
  bottom: 48px;

  ${media.tablet`
    bottom: unset;
    top: 50%;
    transform: translateX(0) translateY(-50%);
  `}
`;

export const CarouselArrowPrev = styled(Arrow).attrs(() => ({
  name: ICON_ARROW_LEFT,
}))`
  left: 50%;
  transform: translateX(calc(-100% - 12px));

  ${media.tablet`
    left: 24px;
  `}
`;

export const CarouselArrowNext = styled(Arrow).attrs(() => ({
  name: ICON_ARROW_RIGHT,
}))`
  right: 50%;
  transform: translateX(calc(100% + 12px));

  ${media.tablet`
    right: 24px;
  `}
`;
